import script from "./RequestUpdateModalForProductImages.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestUpdateModalForProductImages.vue?vue&type=script&setup=true&lang=js"

import "./RequestUpdateModalForProductImages.vue?vue&type=style&index=0&id=3b1ee610&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b1ee610"]])

export default __exports__